import { memo } from 'react';
import { BRAZIL_MAP_VIEW_BOX, BRAZIL_STATE_PATHS } from '../../../constants/brazilStatePaths';
import { STATE_NAMES } from '../../../constants/stateNames';
import styles from './BrazilMapSVG.module.css';

const STATE_ENTRIES = Object.entries(BRAZIL_STATE_PATHS);

interface BrazilMapSVGProps {
	selectedStateCodes: string[];
	disabledStateCodes?: string[];
	onToggleState?: (code: string) => void;
}

const stateClassName = (isSelected: boolean, isDisabled: boolean, isClickable: boolean) => {
	if (isDisabled) return `${styles.statePath} ${styles.stateDisabled}`;
	const fill = isSelected ? styles.stateSelected : styles.stateBase;
	return `${styles.statePath} ${fill} ${isClickable ? styles.stateClickable : ''}`;
};

export const BrazilMapSVG = memo(({ selectedStateCodes, disabledStateCodes, onToggleState }: BrazilMapSVGProps) => (
	<svg viewBox={BRAZIL_MAP_VIEW_BOX} className={styles.svg} preserveAspectRatio="xMidYMid meet" aria-hidden={!onToggleState}>
		{STATE_ENTRIES.map(([code, d]) => {
			const isDisabled = !!disabledStateCodes?.includes(code);
			return (
				<path
					key={code}
					d={d}
					className={stateClassName(selectedStateCodes.includes(code), isDisabled, !!onToggleState)}
					onClick={onToggleState && !isDisabled ? () => onToggleState(code) : undefined}
				>
					{onToggleState && <title>{STATE_NAMES[code] ?? code}</title>}
				</path>
			);
		})}
	</svg>
));

BrazilMapSVG.displayName = 'BrazilMapSVG';
